import { render } from "./LanguageMenu.vue?vue&type=template&id=99314ce0"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\tmp\\hybrid-web-api\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__